import { type FC } from 'react';
import { Input } from 'antd';
import clsx from 'clsx';

interface Props {
    label: string
    value: string
    fieldKey: string
    isEditing: boolean
    setField: (key: string, value: string) => void
    readOnly?: boolean
}

export const ProfileField: FC<Props> = ({ label, value, fieldKey, isEditing, setField, readOnly = false }) => {
    const canEdit = isEditing && !readOnly;

    return (
        <div className={clsx(
            'p-4 rounded-lg border-2 transition-all duration-300',
            'bg-gray-50 border-gray-200',
            'dark:bg-surface-medium dark:border-borders',
            canEdit && 'ring-2 ring-blue-500/20 dark:ring-blue-400/20'
        )}>
            <label className={clsx(
                'block text-sm font-semibold mb-2 transition-colors duration-300',
                'text-gray-700 dark:text-gray-300'
            )}>
                {label}
            </label>
            {canEdit ? (
                <Input
                    value={value}
                    onChange={(e) => setField(fieldKey, e.target.value)}
                    className={clsx(
                        '[&_.ant-input]:bg-white',
                        '[&_.ant-input]:dark:bg-surface-dark',
                        '[&_.ant-input]:border-gray-300',
                        '[&_.ant-input]:dark:border-borders',
                        '[&_.ant-input]:text-gray-900',
                        '[&_.ant-input]:dark:text-white',
                        '[&_.ant-input]:placeholder:text-gray-400',
                        '[&_.ant-input]:dark:placeholder:text-gray-500',
                        '[&_.ant-input]:focus:border-blue-500',
                        '[&_.ant-input]:dark:focus:border-blue-400',
                        '[&_.ant-input]:focus:shadow-md',
                        '[&_.ant-input]:dark:focus:shadow-blue-500/20'
                    )}
                />
            ) : (
                <p className={clsx(
                    'text-sm transition-colors duration-300',
                    'text-gray-900 dark:text-white',
                    !value && 'text-gray-400 dark:text-gray-500 italic'
                )}>
                    {value || 'No especificado'}
                </p>
            )}
        </div>
    );
};
